export enum TimeRangeEnum {
  AFTERNOON = 'AFTERNOON',
  ALL_DAY = 'ALL_DAY',
  MORNING = 'MORNING'
}
